const numberFormatter = new Intl.NumberFormat('fr', { maximumFractionDigits: 10 });

const isNotANumber = (value: any) => value === '' || isNaN(value);

export const formatNumber = (value: number) =>
  value === null || value === undefined || isNotANumber(value) ? '' : numberFormatter.format(value);
